<div class="container mt-4">
  <div
    style="text-align: -webkit-center; font-size: x-large; font-weight: bold"
    class="pb-4"
  >
    {{ "VatRegistrationCertificate" | translate }}
  </div>
  <object
    class="pdf-object"
    id="pdf"
    data="https://storage.googleapis.com/evento_bucket/assets/VAT.pdf"
    type="application/pdf"
    width="100%"
    height="100%"
  >
    <p>
      Your browser does not support PDFs.
      <a href="https://storage.googleapis.com/evento_bucket/assets/VAT.pdf"
        >Download the PDF</a
      >.
    </p>
  </object>
</div>

<!-- <app-footer></app-footer> -->
